import { Flex, Text } from "@chakra-ui/react";
import { DroppableBox } from "components/containers/InspectionFormat/containers/LayoutFrameBuilder";
import { SOURCE } from "components/containers/InspectionFormat/Content/SettingPinLayoutFrame/context/pinLayoutFrameReducer";
import { DateTimeIcon } from "components/icon";

import {
  DateAdditionalInfo,
  DATE_FORMAT_OPTIONS,
} from "interfaces/models/inspectionItemResult";
import FieldPreviewWrapper from "../../../components/FieldPreviewWrapper";
import { FieldPreviewProps } from "../../types";

import DatePicker from "components/DatePicker";
import { memo, useState } from "react";

interface DatePreviewerProps extends FieldPreviewProps<string> {}

const DatePreviewer: React.FC<DatePreviewerProps> = ({
  item,
  value,
  isReadOnly,
  isLoading,
  isDraggable,
  index,
  allItemResultCount,
  prevItemResultCount,
  onChange,
}) => {
  const additionInfo = item.additionInfo as DateAdditionalInfo;
  const formatType = additionInfo.formatType;
  const [isShowCalendar, setIsShowCalendar] = useState<boolean>(false);

  const placeholderText =
    DATE_FORMAT_OPTIONS.find((item) => item.value === additionInfo.formatType)
      ?.label || "日付";

  if (isDraggable) {
    return (
      <>
        <FieldPreviewWrapper
          title={item.name}
          index={index}
          prevItemResultCount={prevItemResultCount}
          allItemResultCount={allItemResultCount}
          data-type={item.dataType}
        >
          <DroppableBox
            flex={1}
            name={item.name}
            icon={<DateTimeIcon w="3rem" h="3rem" />}
            id={item.id}
            source={SOURCE.INSPECTION_FORM}
          >
            <Flex
              className="draggable-area"
              alignItems="center"
              backgroundColor="white"
              height="4rem"
              maxWidth="100%"
              width="100%"
              fontSize="1rem"
              color="#171717"
              border="1px solid #D4D4D4"
              padding="6px 10px 5px 0px"
            >
              <DateTimeIcon
                color="#525252"
                width="2.4rem"
                height="2.4rem"
                padding="0.5rem"
              />
              <Text color="#A3A3A3">{placeholderText}</Text>
            </Flex>
          </DroppableBox>
        </FieldPreviewWrapper>
      </>
    );
  }

  return (
    <FieldPreviewWrapper
      index={index}
      prevItemResultCount={prevItemResultCount}
      allItemResultCount={allItemResultCount}
      title={item.name}
    >
      <DatePicker
        value={value}
        showIcon
        isShowCalendar={isShowCalendar}
        placeholderText={placeholderText}
        formatType={formatType}
        isLoading={isLoading}
        isReadOnly={isReadOnly}
        setIsShowCalendar={setIsShowCalendar}
        onChange={onChange as any}
      />
    </FieldPreviewWrapper>
  );
};

export default memo(DatePreviewer);
